import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

const InputField = ({ label, description, placeholder, name, maxLength, touched, error, onChange, value }) => {
  const classNames = ['input-field'];

  if (!!error && touched) classNames.push('input-field--error');

  return (
    <div className={classNames.join(' ')}>
      <label className="input-field__label" htmlFor={name}>
        {label}
      </label>
      <div className="input-field__description">
        <Markdown>{description}</Markdown>
      </div>
      <input
        className="input-field__input"
        id={name}
        name={name}
        placeholder={placeholder}
        type="text"
        maxLength={maxLength}
        onChange={onChange}
        value={value}
      />
      {!!error && touched && <div className="input-field__error">{error}</div>}
    </div>
  );
};

export default InputField;
